import { render, staticRenderFns } from "./customerRecommend.vue?vue&type=template&id=134d824f&scoped=true&"
import script from "./customerRecommend.vue?vue&type=script&lang=js&"
export * from "./customerRecommend.vue?vue&type=script&lang=js&"
import style0 from "./customerRecommend.vue?vue&type=style&index=0&id=134d824f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d824f",
  null
  
)

export default component.exports